import { StrapiType } from "@/src/type/strapi";
import { get } from "./StrapiService";

async function getLocales() {
  const response = await get<StrapiType.StrapiLocales>(undefined, undefined, undefined, "i18n/locales");
  return Array.isArray(response?.response) ? response?.response : [];
}

export default {
  getLocales,
};
